
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.468 13.342l.534-3.475h-3.334V7.612c0-.95.465-1.877 1.959-1.877h1.515V2.777s-1.375-.235-2.69-.235c-2.746 0-4.54 1.665-4.54 4.677v2.649H6.859v3.474h3.053v8.4h3.756v-8.4h2.8z","fill":"#ABAFB5"}})])
          )
        }
      }
    